const homeconfig = [{
        "column": 2,
        "children": [{
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one", "two", "three", "four"],
                "children": [],
                "checked": false
            },
            {
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one",
                    "two", "three", "four"
                ],
                "children": [],
                "checked": false
            }
        ]
    },
    {
        "column": 4,
        "children": [{
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one", "two", "three", "four"],
                "children": [],
                "checked": false
            },
            {
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one", "two", "three", "four"],
                "children": [],
                "checked": false
            },
            {
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one", "two", "three", "four"],
                "children": [],
                "checked": false
            },
            {
                "name": "用户信息",
                "componentname": "LoginUserInfo",
                "supportType": ["one", "two", "three", "four"],
                "children": [],
                "checked": false
            }
        ]
    },
    {
        "column": 3,
        "children": [{
            "name": "用户信息",
            "componentname": "LoginUserInfo",
            "supportType": ["one", "two", "three", "four"],
            "children": [],
            "checked": false
        }, {
            "name": "用户信息",
            "componentname": "LoginUserInfo",
            "supportType": ["one", "two",
                "three", "four"
            ],
            "children": [],
            "checked": false
        }, {
            "name": "用户信息",
            "componentname": "LoginUserInfo",
            "supportType": ["one", "two", "three", "four"],
            "children": [],
            "checked": false
        }]
    }, {
        "column": 1,
        "children": [{
            "name": "用户信息",
            "componentname": "LoginUserInfo",
            "supportType": ["one", "two", "three", "four"],
            "children": [],
            "checked": false
        }]
    }
]

const systemStyle = {
    Layout: 'MenuLeft', //布局方式
    Theme: 'blue-theme' //主题(默认蓝色系)
}


export {
    homeconfig,
    systemStyle
}


// WEBPACK FOOTER //
// ./src/config/systemsettings.js